// Short synthesised UI blips for menu navigation. They are deliberately different from the quiz's
// correct-answer sound so that sound keeps meaning "you got it right". Silent where Web Audio is
// unavailable (old browsers, tests).

let context = null;

function audioContext() {
  if (context) return context;
  const AudioContextCtor = typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext);
  if (!AudioContextCtor) return null;
  try {
    context = new AudioContextCtor();
  } catch {
    return null;
  }
  return context;
}

function playNotes(notes, volume) {
  const ac = audioContext();
  if (!ac) return;
  if (ac.state === 'suspended') ac.resume().catch(() => {});
  const now = ac.currentTime;
  notes.forEach(({ freq, at, length }) => {
    const oscillator = ac.createOscillator();
    const gain = ac.createGain();
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(freq, now + at);
    gain.gain.setValueAtTime(0.0001, now + at);
    gain.gain.exponentialRampToValueAtTime(volume, now + at + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + at + length);
    oscillator.connect(gain).connect(ac.destination);
    oscillator.start(now + at);
    oscillator.stop(now + at + length + 0.02);
  });
}

/** Picking a section or topic: a quick upward "pop". */
export const playSelect = () => playNotes([{ freq: 660, at: 0, length: 0.08 }, { freq: 880, at: 0.05, length: 0.1 }], 0.08);

/** Opening a year group: a single soft tick. */
export const playOpen = () => playNotes([{ freq: 523, at: 0, length: 0.07 }], 0.05);

/** Starting a lesson: a rising three-note "let's go". */
export const playStart = () =>
  playNotes(
    [
      { freq: 523, at: 0, length: 0.1 },
      { freq: 659, at: 0.08, length: 0.1 },
      { freq: 784, at: 0.16, length: 0.2 },
    ],
    0.09,
  );
